var map = {
	"./Uptech-marker-alerts-icon-high-anchor.png": 86748,
	"./Uptech-marker-alerts-icon-high-animal.png": 98908,
	"./Uptech-marker-alerts-icon-high-boat.png": 72368,
	"./Uptech-marker-alerts-icon-high-deformation.png": 29468,
	"./Uptech-marker-alerts-icon-high-electric-tower.png": 39613,
	"./Uptech-marker-alerts-icon-high-intrusion.png": 82684,
	"./Uptech-marker-alerts-icon-high-landslide.png": 78828,
	"./Uptech-marker-alerts-icon-high-leaks.png": 5616,
	"./Uptech-marker-alerts-icon-high-machinery.png": 41327,
	"./Uptech-marker-alerts-icon-high-manhole.png": 92184,
	"./Uptech-marker-alerts-icon-high-rock-falling.png": 28656,
	"./Uptech-marker-alerts-icon-high-temperature.png": 6328,
	"./Uptech-marker-alerts-icon-high-vehicle.png": 20592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70124;